import { Link } from 'react-router-dom'
import { Icons } from '@/theme/Images'
import { useGetRecurringPayment } from '../../hooks/use-get-recurring-payment'
import { AUTOPAY_RETRIEVED } from '../data'
import { useEffect, useState } from 'react'

export default function AutoPayIndicator() {
  const { data } = useGetRecurringPayment()
  const [autoPayActive, setAutoPayActive] = useState(false)

  useEffect(() => {
    if (!data) {
      setAutoPayActive(false)
      return
    }

    setAutoPayActive(data.message.includes(AUTOPAY_RETRIEVED))
  }, [data])

  return (
    <div className="flex flex-row flex-wrap md:justify-end justify-between items-center w-full h-[18px] gap-2">
      <div className="flex items-center">
        <img src={autoPayActive ? Icons.blueIndicatorIcon : Icons.grayIndicatorIcon} alt="icon" className="mr-1" />
        <p className="text-right text-nowrap font-normal text-[12px] text-neutral-700">
          AutoPay {autoPayActive ? 'on' : 'off'}
        </p>
      </div>
      <div className="flex">
        {!autoPayActive ? (
          <Link
            className="text-xs/[18px] text-right font-medium text-neutral-700 cursor-pointer"
            to="/payments/auto-pay"
          >
            <button id="start-autopay-button" aria-label="Start AutoPay" className="text-nowrap font-semibold text-xs">
              Start AutoPay
            </button>
          </Link>
        ) : null}
      </div>
    </div>
  )
}
